import React from 'react'
import PropTypes from 'prop-types'
import {ArcElement, Chart as ChartJS} from "chart.js"
import {Doughnut} from "react-chartjs-2"


ChartJS.register(ArcElement)

const options = {
    cutout: "64%",
    plugins: {
        legend: {
            display: false,
        },
        title: {
            display: false,
        },
        tooltip: {
            displayColors: false,
            bodyAlign: "center",
            callbacks: {
                title: () => "",
                label: (data) => [
                    data.label + ":",
                    data.raw.toLocaleString("de-DE", {
                        style: "currency",
                        currency: "EUR",
                        minimumFractionDigits: 2,
                    }),
                ],
            },
        },
    },
}

const TpUiDonutChart = ({data}) => <Doughnut options={options} data={data}/>

TpUiDonutChart.propTypes = {
    data: PropTypes.exact({
        labels: PropTypes.arrayOf(PropTypes.string),
        datasets: PropTypes.arrayOf(
            PropTypes.exact({
                label: PropTypes.string,
                data: PropTypes.arrayOf(PropTypes.string),
                backgroundColor: PropTypes.string,
            }),
        ),
    }),
}

export default TpUiDonutChart
